import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '@app/core/auth.service';

import { RedirectPromptModalComponent } from '../redirect-prompt-modal.component';

@Component({
  selector: 'om-login-prompt-modal',
  templateUrl: '../redirect-prompt-modal.component.html',
  styleUrls: ['../redirect-prompt-modal.component.scss'],
})
export class LoginPromptModalComponent extends RedirectPromptModalComponent {
  private static readonly TYPE_NAME = 'LoginPromptModalComponent';

  constructor(private authService: AuthService, protected modal: NgbActiveModal) {
    super(modal);
  }

  redirect(): void {
    this.authService.goLogin({
      path: this.redirectUrl,
      trackingSource: LoginPromptModalComponent.TYPE_NAME,
    });
    super.redirect();
  }
}
